export const iconFontAwesomeHumanitarianPersonCane = (
	<i className="fa-solid fa-person-cane"></i>
);
